import { Component } from '@angular/core';
import {
  AccountService
} from '../../../../_services';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
@Component({
  selector: 'dgx-layout',
  templateUrl: 'dgx-layout.component.html',
  styleUrls: ['dgx-layout.component.css']
})
export class DGXLayoutComponent {
  title = 'DGX';
  closeResult: string;
  link: any = {
    id: 1,
    'label': "DGX Home",
    'path': '/access/demo/dgx-home',
  };
  searchForm: UntypedFormGroup;
  constructor(
    private accountService: AccountService, private formBuilder: UntypedFormBuilder) {
    this.accountService.user.subscribe(x => {});
  }
  ngOnInit() {
    this.searchForm = this.formBuilder.group({
      search: ['']
    });
    this.link.id = 1;
    this.link.label = 'DGX Home';
    this.link.path = '/access/demo/dgx-home';
    this.activeListItem = this.link;
    this.activeListItem.id = this.link.id;
    this.sortLinksItems(event, this.link, 1);
    this.setLinkItemStyle(this.link);
  }
  activeListItem: any = null;
  links: any[] = [{
      id: 1,
      label: 'DGX Home',
      path: '/access/demo/dgx-home',
    }, {
      id: 2,
      label: 'Profile ',
      path: '/access/demo/profile',
    }, {
      id: 3,
      label: 'Lookup',
      path: '/access/demo/lookup',
    }, {
      id: 4,
      label: 'Standardize Name and Address',
      path: '/access/demo/standardize-name-and-address',
    }, {
      id: 5,
      label: 'Product List ',
      path: '/access/demo/product-list'
    }, {
      id: 6,
      label: 'Orders and Investigations',
      path: '/access/demo/orders-and-investigations'
    }, {
      id: 7,
      label: 'List Orders',
      path: '/access/demo/list-orders'
    }, {
      id: 8,
      label: 'List Orders_V2 ',
      path: '/access/demo/list-orders-v2'
    }, {
      id: 9,
      label: 'Preference',
      path: '/access/demo/preference'
    }, {
      id: 10,
      label: 'Family Tree',
      path: '/access/demo/family-tree'
    }, {
      id: 11,
      label: 'Public Records Search',
      path: '/access/demo/public-records-search'
    }, {
      id: 12,
      label: 'Public Records Details',
      path: '/access/demo/public-records-details'
    },
    {
      id: 13,
      label: 'Add Registration',
      path: '/access/demo/add-registration'
    }, {
      id: 14,
      label: 'Get Registration List',
      path: '/access/demo/get-registration-list'
    }, {
      id: 15,
      label: 'Get HeadQuarter Registration List',
      path: '/access/demo/headquarter-registration-list'
    }, {
      id: 16,
      label: 'Get Registration Activity',
      path: '/access/demo/registration-activity'
    }, {
      id: 17,
      label: 'Get Notifications',
      path: '/access/demo/notifications'
    }, {
      id: 18,
      label: 'Modify Registration',
      path: '/access/demo/modify-registration'
    }, {
      id: 19,
      label: 'Transfer Registration',
      path: '/access/demo/transfer-registration'
    }, {
      id: 20,
      label: 'Get Baseline Information',
      path: '/access/demo/get-baseline-information'
    }, {
      id: 21,
      label: 'Get Notification Count',
      path: '/access/demo/get-notification-count'
    }
  ];
  sortLinksItems(event, link, i) {
    this.activeListItem = link;
      

  }
  setLinkItemStyle(link) {
    return {
      'background-color': this.activeListItem && this.activeListItem.id == link.id ? '#003B53' : null
    };
  }
  logout() {
    this.accountService.logout();
    return true;
  }


}
